import { useState } from 'react';
import BlogManagement from './BlogManagement';
import BlogEditor from './BlogEditor';
import type { BlogPost } from './types';

function BlogPage() {
  const [currentView, setCurrentView] = useState<'list' | 'edit'>('list');
  const [editingPost, setEditingPost] = useState<BlogPost | undefined>();

  const handleEdit = (post: BlogPost) => {
    setEditingPost(post);
    setCurrentView('edit');
  };

  const handleNew = () => {
    setEditingPost(undefined);
    setCurrentView('edit');
  };

  const handleSave = () => {
    setCurrentView('list');
    setEditingPost(undefined);
  };

  const handleCancel = () => {
    setCurrentView('list');
    setEditingPost(undefined);
  };

  return (
    <>
      {currentView === 'list' ? (
        <BlogManagement onEdit={handleEdit} onNew={handleNew} />
      ) : (
        <BlogEditor 
          post={editingPost}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      )}
    </>
  );
}

export default BlogPage;